module.exports = __webpack_public_path__ + "img/group-2283-white.057f1915.svg";